import React, { memo } from 'react';
import { compose } from 'recompose';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Tooltip from '../../../../../common/StyledToolTip';
import styles from '../../../../../../layout/layoutHeader/components/styles';
import EquipmentDefectsIcon from '../../../../../../layout/icons/EquipmentDefects';

const EquipmentDefects = ({ classes, handleClick, theme }) => {
  return (
    <div className={`${classes.headerIconStyles} ${classes.iconLayout}`}>
      <Tooltip title="E-DVIR info">
        <div onClick={handleClick}>
          <EquipmentDefectsIcon color={theme.iconColor} />
        </div>
      </Tooltip>
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(memo(EquipmentDefects));
